/* eslint-disable prefer-destructuring */
/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */

import { filterData } from './filter-data';

export const sortData = (data, key = 'false', order) => {
  let sorted = (data.sorted ? data : {});
  sorted.order = order;
  if (!sorted.sorted) {
    sorted.items = [];
    if (data.length > 0) {
    // add sortable date property
      data.forEach((item) => {
        const newItem = item;
        const dateStr = item[key];
        const dateStamp = Math.round((new Date(dateStr)).getTime() / 1000);
        newItem.dateStamp = dateStamp;
        newItem.visible = true;
        sorted.items.push(newItem);
      });
      sorted.sorted = true;
      // eslint-disable-next-line no-undef
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const urlFacets = urlParams.get('facets');
        if (urlFacets !== null) {
          const facetsExplode = urlFacets.split('|');
          sorted.facets = {
            location: (facetsExplode[0] !== '' ? facetsExplode[0] : false),
            category: (facetsExplode[1] !== '' ? facetsExplode[1] : false),
            civilian: (facetsExplode[2] !== '' ? facetsExplode[2] : false),
            totalCount: sorted.items.length,
          };
          sorted = filterData(sorted);
        } else {
          sorted.facets = {
            location: false,
            category: false,
            civilian: false,
            totalCount: sorted.items.length,
          };
        }
      }
    }
  }
  if (order === 'ASC') {
    sorted.items.sort((a, b) => (a.fields.datestamp - b.fields.datestamp));
  } else if (order === 'DESC') {
    sorted.items.sort((a, b) => (b.fields.datestamp - a.fields.datestamp));
  }
  return sorted;
};
